// extracted by mini-css-extract-plugin
export default {"mainLink":"MainLink_mainLink__4ZHyb","Shimiring":"MainLink_Shimiring__ucTFC"};